var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{ref:"loadMoreButton",on:{"click":_vm.load}},[_vm._t("default",[_vm._v("Load more…")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }